/**
 * Created by tofael on 7/18/17.
 */
import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

const ConfirmationDialog = ({alertText, handleClose, handleOk, open})=>{
  const actions = [
    <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={handleClose}
    />,
    <FlatButton
        label="Yes"
        primary={true}
        onTouchTap={handleOk}
    />,
  ];

  return (
      <div>
        <Dialog
            actions={actions}
            modal={false}
            open={open}
            onRequestClose={handleClose}
        >
          {alertText}
        </Dialog>
      </div>
  );
};
export default ConfirmationDialog;


// WEBPACK FOOTER //
// ./src/screens/shared/confirmation-dialog.js